/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
  0.25: '0.0625rem',
  0.5: '0.125rem',
  0.65: '0.1625rem',
  0.75: '0.1875rem',
  1: '0.25rem',
  1.25: '0.3125rem',
  1.375: '0.34375rem',
  1.5: '0.375rem',
  1.75: '0.4375rem',
  2: '0.5rem',
  2.25: '0.5625rem',
  2.375: '0.59375rem',
  2.5: '0.625rem',
  2.75: '0.6875rem',
  3: '0.75rem',
  3.25: '0.8125rem',
  3.5: '0.875rem',
  3.75: '0.9375rem',
  4: '1rem',
  4.25: '1.0625rem',
  4.5: '1.125rem',
  4.7: '1.175rem',
  4.75: '1.1875rem',
  5: '1.25rem',
  5.25: '1.3125rem',
  5.5: '1.375rem',
  5.75: '1.4375rem',
  6: '1.5rem',
  6.25: '1.5625rem',
  6.5: '1.625rem',
  6.75: '1.6875rem',
  6.875: '1.71875rem',
  7: '1.75rem',
  7.25: '1.8125rem',
  7.5: '1.875rem',
  8: '2rem',
  8.5: '2.125rem',
  8.75: '2.1875rem',
  9: '2.25rem',
  9.5: '2.375rem',
  10: '2.5rem',
  10.25: '2.5625rem',
  10.5: '2.625rem',
  10.75: '2.6875rem',
  11: '2.75rem',
  11.25: '2.8125rem',
  11.75: '2.9375rem',
  12: '3rem',
  12.5: '3.125rem',
  12.75: '3.1875rem',
  13: '3.25rem',
  13.5: '3.375rem',
  13.75: '3.4375rem',
  14: '3.5rem',
  15: '3.75rem',
  15.25: '3.8125rem',
  15.5: '3.875rem',
  16: '4rem',
  17: '4.25rem',
  17.5: '4.375rem',
  18: '4.5rem',
  18.25: '4.5625rem',
  18.5: '4.625rem',
  19: '4.75rem',
  20: '5rem',
  21: '5.25rem',
  22.5: '5.625rem',
  24: '6rem',
  25: '6.25rem',
  27.75: '6.9375rem',
  26.75: '6.6875rem',
  28: '7rem',
  29.25: '7.3125rem',
  30: '7.5rem',
  31.25: '7.8125rem',
  32: '8rem',
  32.5: '8.125rem',
  33.5: '8.375rem',
  34.75: '8.6875rem',
  35: '8.75rem',
  37: '9.25rem',
  37.5: '9.375rem',
  42: '10.5rem',
  50: '12.5rem',
  53.75: '13.4375rem',
  54.25: '13.5625rem',
  54.5: '13.625rem',
  54.75: '13.6875rem',
  55: '13.75rem',
  56.25: '56.25rem',
  56.75: '14.1875rem',
  57.25: '14.3125rem',
  57.5: '14.375rem',
  62.5: '15.625rem',
  63.5: '15.875rem',
  65: '16.25rem',
  66.5: '16.625rem',

  configurationSelectorSlotMinH: '7.875rem',
  configurationSelectorSlotImageH: '5.5rem',
  configurationSelectorRadioExtraPriceMaxW: '2.8125rem',

  container: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1200px',
    xxl: '1440px',
    xxxl: '1560px',
  },
  chooseYourSetsSetCardMax: '22.625rem',
  editorial: '620px',
  supportSidebar: '290px',
  doubleImageSmall: '158px',
  doubleImageLarge: '440px',
  iconSetMax: '1142px',
  iconSetColumn: '255.5px',
  iconSetColumnBase: '144px',
  teaserTileBlockMax: '1280px',

  /** Shop the Look — layout tokens (avoid clashing numeric keys e.g. 30 = 7.5rem, 37.5 = 9.375rem) */
  shopTheLookMarketingCol: '24rem',
  shopTheLookHotspotPanelH: '37.5rem',
  shopTheLookDrawerMaxW: '30rem',
  shopTheLookHotspotPanelMinVHCap: '40rem',
  shopTheLookMediaFallbackMinH: '15rem',
};
